import * as AuthStore from './store/AuthStore';

export const createAuth = (getState) => {
    return{
        username: getState()[AuthStore.reducerName].orgId,
        password: getState()[AuthStore.reducerName].apiKey
    }
}